export default __webpack_public_path__ + "static/media/hilden_2_dark.4964e0ff.png";